import SectionWrapper from '@components/common/SectionWrapper'
import { FaHeart, FaPatreon } from 'react-icons/fa'

export const PATREON_URL =
  'https://patreon.com/Hayirhah?utm_medium=unknown&utm_source=join_link&utm_campaign=creatorshare_creator&utm_content=copyLink'

const PatreonBanner = () => {
  return (
    <SectionWrapper noBg className="mx-auto w-full">
      <a
        href={PATREON_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center justify-center gap-2 rounded-lg border border-primary-400/30 bg-linear-to-r from-primary-50/80 to-secondary-50/80 py-2 text-sm transition-all duration-200 hover:from-primary-100/90 hover:to-secondary-100/90 hover:border-primary-400/50 dark:from-primary-dark-400/30 dark:to-primary-dark-300/30 dark:border-primary-400/20 dark:hover:from-primary-dark-400/40 dark:hover:to-primary-dark-300/40 dark:hover:border-primary-400/40"
      >
        <FaPatreon className="text-red-500 dark:text-red-400" />
        <span className="font-medium bg-linear-to-r from-primary-600 to-primary-500 dark:from-primary-300 dark:to-primary-200 bg-clip-text text-transparent">
          Hayırhah&apos;ı Destekle
        </span>
        <FaHeart className="text-xs text-red-500 dark:text-red-400 animate-pulse" />
      </a>
    </SectionWrapper>
  )
}

export default PatreonBanner
